import { useScrollAnimation, getStaggerProps, animationClasses } from '@/hooks/useScrollAnimation';

const identityItems = [
  { label: '正式名稱', value: '財經錢線文化有限公司' },
  { label: '網站簡稱', value: '財經錢線' },
  { label: '英文名稱', value: 'FINELINE' },
];

const publishingDirections = [
  {
    icon: 'ri-funds-line',
    title: '商業理財',
    description: '涵蓋商業觀念、經濟思考、管理、職場與理財相關閱讀內容。',
  },
  {
    icon: 'ri-psychotherapy-line',
    title: '心理學',
    description: '涵蓋情緒、自我理解、人際關係與大眾心理學等閱讀主題。',
  },
  {
    icon: 'ri-history-line',
    title: '以古諷今',
    description: '透過歷史事件、人物與思想觀點，連結當代社會及人文議題。',
  },
];

export default function BrandIntroSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref} className="min-h-[100svh] flex items-center bg-background-100 py-12 md:py-16">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">

          {/* ── Section Header ── */}
          <div className={`text-center mb-10 md:mb-12 ${animationClasses.base} ${isVisible ? animationClasses.visible : animationClasses.hidden}`}>
            <span className="inline-block text-xs font-medium text-accent-600 tracking-wider uppercase mb-3">
              品牌資訊
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3 tracking-tight">
              認識財經錢線
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              商業思考、心理理解與人文觀察
            </p>
          </div>

          {/* ── Brand Identity ── */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10 md:mb-12">
            {identityItems.map((item, i) => (
              <div
                key={item.label}
                {...getStaggerProps(isVisible, i, 100)}
                className="text-center p-5 rounded-xl bg-background-50 border border-background-200/70"
              >
                <p className="text-xs font-medium text-foreground-400 tracking-wider uppercase mb-2">
                  {item.label}
                </p>
                <p className="text-base md:text-lg font-semibold text-foreground-900">
                  {item.value}
                </p>
              </div>
            ))}
          </div>

          {/* ── Publishing Directions ── */}
          <div className="mb-10 md:mb-12">
            <div {...getStaggerProps(isVisible, 0, 200)} className="text-center mb-6">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2 tracking-tight">
                出版定位
              </h3>
              <p className="text-foreground-500 text-sm md:text-base">
                商業理財、心理學與以古諷今類書籍
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              {publishingDirections.map((dir, i) => (
                <div
                  key={dir.title}
                  {...getStaggerProps(isVisible, i, 280)}
                  className="p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300/40 transition-colors"
                >
                  <div className="w-10 h-10 flex items-center justify-center mb-4 rounded-lg bg-primary-50">
                    <i className={`${dir.icon} text-primary-500 text-lg`}></i>
                  </div>
                  <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                    {dir.title}
                  </h4>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {dir.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* ── Brand Introduction ── */}
          <div className={`max-w-3xl mx-auto text-center mb-10 md:mb-12 ${animationClasses.base} ${isVisible ? animationClasses.visible : animationClasses.hidden}`}>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              財經錢線以商業理財、心理學與以古諷今類書籍為主要出版方向，透過商業知識、心理理解及歷史與當代議題的連結，提供讀者多元的知識閱讀內容。網站呈現財經錢線的品牌定位、2026 最新發行書籍與相關出版資訊。
            </p>
          </div>

          {/* ── Relationship & CTA ── */}
          <div className={`max-w-3xl mx-auto text-center ${animationClasses.base} ${isVisible ? animationClasses.visible : animationClasses.hidden}`}>
            <div className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70">
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
                本品牌委託崧博出版經銷，官方網站由崧博出版製作。
              </p>
              <p className="text-foreground-500 text-sm leading-relaxed mb-6">
                完整書名、作者與出版資訊，請前往崧博書籍資料庫查詢。
              </p>
              <a
                href="https://catalog.sonbook.net/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                前往書籍資料庫
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-external-link-line text-sm"></i>
                </span>
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}